import * as React from 'react'
import classNames from 'classnames'
import { LucideIcon } from 'utils/lucideIcon'
import { LIST } from 'capacity/copy'

interface CapacitySearchProps {
    value: string
    onChange: (value: string) => void
    inputRef?: React.RefObject<HTMLInputElement>
    collapsed?: boolean
}

export function CapacitySearch({ value, onChange, inputRef, collapsed = false }: CapacitySearchProps) {
    return (
        <div
            className={classNames('capacity-search', { 'is-filled': value !== '', 'is-collapsed': collapsed })}
            aria-hidden={collapsed}
        >
            <LucideIcon iconName="Search" size={16} className="capacity-search-icon" />
            <input
                type="text"
                className="capacity-search-input"
                ref={inputRef}
                placeholder={LIST.search}
                aria-label={LIST.search}
                autoComplete="off"
                value={value}
                disabled={collapsed}
                tabIndex={collapsed ? -1 : undefined}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    )
}
